const getIsServer = () => typeof window === 'undefined'

export default getIsServer
